import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../locales/en.json";
import ur from "../locales/ur.json";
import { getRole } from "./auth";
import { defaultLanguage, forgetLanguageChoice } from "./language";
import type { Role } from "../types";

const language = defaultLanguage(getRole());

function applyLanguage(nextLanguage: string): void {
  document.documentElement.lang = nextLanguage;
  document.documentElement.dir = nextLanguage === "ur" ? "rtl" : "ltr";
}

export function applyDefaultLanguage(role: Role): void {
  if (role === "teacher") forgetLanguageChoice();
  void i18n.changeLanguage(defaultLanguage(role));
}

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, ur: { translation: ur } },
  lng: language,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

applyLanguage(language);
i18n.on("languageChanged", applyLanguage);

export default i18n;
